import { CoverBackground } from 'components/CoverBackground'
import Link from 'next/link'
import { ComponentType } from 'react'
import { FormattedDate } from 'react-intl'
import { Col, Container, Row } from 'reactstrap'

export const FeaturedPost: ComponentType<{ post: any }> = ({ post }) => {
  return (
    <Container>
      <Row>
        <Col lg={8}>
          <CoverBackground url={post.feature_image} className="aspect-50 rounded-lg" />
        </Col>
        <Col lg={4} className="py-30">
          {post.primary_tag && (
            <h6 className="mb-15 font-size-14 text-uppercase text-primary font-weight-bold">{post.primary_tag.name}</h6>
          )}
          <Link
            href={{
              pathname: '/blog/[postSlug]',
              query: { postSlug: post.slug },
            }}
            as={`/blog/${post.slug}`}
          >
            <a
              title={post.title}
              className="d-block font-size-26 font-family-serif font-weight-bold line-height-md text-body"
            >
              {post.title}
            </a>
          </Link>
          <p className="pt-10 mb-20 line-height-md">{post.excerpt}</p>
          <h6 className="mb-15 font-size-14 text-uppercase text-raven font-weight-bold">
            <FormattedDate value={post.created_at} day="numeric" month="long" year="numeric" />
          </h6>
        </Col>
      </Row>
    </Container>
  )
}
